





































































































































































































































































































































































































































































































































































import {Component, Mixins} from 'vue-property-decorator';

import ContentSection from '@/components/ContentSection.vue';
import {IContentSection} from '@/components/types';
import PricingPlans from '@/components/PricingPlans.vue';
import {gsap, ScrollTrigger} from '@/utils/gsap';
import Icon from '@/components/ui/Icon.vue';
import ScrollTo from '@/mixins/ScrollTo';
import {TranslateResult} from 'vue-i18n';
import checkIE from '@/utils/ie';

@Component({
	components: {
		'v-content-section': ContentSection,
		'v-pricing-plan': PricingPlans
	}
})
export default class White extends Mixins(ScrollTo) {

	body: HTMLElement | null;
	sw: any = [];
	tl: any;
	currentSlide: number = 0;
	anim: boolean = false;
	ultimateTimeline: any;

	tlArr: any[] = [
		{
			in: null,
			out: null
		},
		{
			in: null,
			out: null
		},
		{
			in: null,
			out: null
		},
	];

	ease: string = 'back.inOut(1.7)';
	easeInOut: string = 'back.inOut(1.7)';
	animationsInited: boolean = false;

	$refs: {
		card: Icon
		visual: ContentSection

		carousel: HTMLElement
		sticky: HTMLElement
		background: HTMLElement
		animationWrapper: HTMLElement
		content: HTMLElement[]
		contentTrigger: HTMLElement[]

		carouselAccount: HTMLElement
		carouselEurope: HTMLElement
		carouselTraveling: HTMLElement

		travelingSVG: SVGElement

	}

	get backgrounds(): TranslateResult {
		return this.$t('cards.white.carousel.bgs');
	}


	get isIE(): boolean {
		return checkIE();
	}

	get content(): IContentSection {
		return {
			headline: this.$t('cards.white.contentSection.headline') as string,
			perex: this.$t('cards.white.contentSection.perex') as string,
			background: {
				alt: 'TODO Fill alt',
				default: require('@/images/white/visual/white-bg.jpg'),
				retina: require('@/images/white/visual/white-bg@2.jpg')
			},
			buttons: [
				{
					variant: 'white',
					to: {
						name: this.$route.name!,
						query: {
							modal: this.appModalName
						},
						params: {
							card: 'white'
						}
					},
					label: this.$t('button.get.white') as string
				},
				{
					variant: 'secondary secondary-white',
					onClick: () => this.scrollToSection(this.$refs.carousel),
					label: this.$t('button.learnMore') as string
				}
			],
			icon: 'symbols/letters/a-white',
			image: {
				alt: 'TODO Fill Alt',
				size: 320 / 210,
				tiny: {
					default: require('@/images/cards/green/green.png'),
					retina: require('@/images/cards/green/green@2.png')
				}
			}
		}
	}

	get appModalName(): string {
		return this.$t('routes.getApp.modalName') as string;
	}

	mounted(): void {

		if (typeof window === 'undefined') {
			return;
		}

		this.resizeHandler();
	}


	initAnimations(): void {

		this.ultimateTimeline = gsap.timeline({paused: true});

		this.ultimateTimeline
			.to(this.$refs.carouselAccount, {
				autoAlpha: 1,
				scale: 1,
				ease: this.ease
			})
			.to(this.$refs.carouselAccount, {
				autoAlpha: 0,
				scale: 0,
				ease: this.ease
			})
			.to(this.$refs.carouselEurope, {
				autoAlpha: 1,
				scale: 1.5,
				ease: this.ease
			})
			.to(this.$refs.carouselEurope, {
				autoAlpha: 0,
				scale: 0,
				ease: this.ease
			})
			.to(this.$refs.carouselTraveling, {
				autoAlpha: 1,
				scale: 1,
				ease: this.ease
			})
	}

	initScrollTrigger(): void {

		let sw = ScrollTrigger.create({
			trigger: this.$refs.carousel,
			animation: this.ultimateTimeline,
			start: 'top center',
			end: 'bottom bottom',
			scrub: 1
		});

		this.sw.push(sw);

		if (!this.$refs.contentTrigger) {
			return;
		}

		this.$refs.contentTrigger.forEach((element: HTMLElement) => {
			let sw = ScrollTrigger.create({
				trigger: element,
				onUpdate: (self: any) => {
					this.currentSlide = this.$refs.contentTrigger.indexOf(self.trigger);
				}
			});
			this.sw.push(sw);
		});

	}

	stickyScroll(): void {

		if (!this.$refs.sticky) {
			return;
		}

		let sw = ScrollTrigger.create({
			trigger: this.$refs.sticky,
			start: 'top top',
			end: 'bottom bottom',
			pin: true,
			pinSpacing: false
		});

		this.sw.push(sw);
	}

	handleOutAnimations(): void {
		this.tlArr.forEach((timeline: any) => {
			timeline.out.play(0);
		})
	}

	stickyBackground(): void {
		if (!this.$refs.background) {
			return;
		}
		let sw = ScrollTrigger.create({
			trigger: this.$refs.carousel,
			start: 'top top',
			end: 'bottom bottom',
			pin: this.$refs.background,
			pinSpacing: false,
			scrub: 1.5
		});

		this.sw.push(sw);
	}

	async resizeHandler(): Promise<void> {

		if (window.innerWidth > 767 && !this.animationsInited) {

			await this.initAnimations();

			if (this.isIE) {
				await this.stickyBackground();
				await this.stickyScroll();
			}

			await this.initScrollTrigger();

			this.animationsInited = true;

		}
	}

	beforeDestroy() {
		if (this.sw.length === null || typeof this.sw === 'undefined') {
			return;
		}
		this.sw.forEach((scrollTrigger: any) => scrollTrigger.kill());
	}


}
